import BookingModal from './BookingModal';

export default BookingModal;
